import { render } from "./PledgesList.vue?vue&type=template&id=641eced1&scoped=true"
import script from "./PledgesList.vue?vue&type=script&lang=js"
export * from "./PledgesList.vue?vue&type=script&lang=js"

import "./PledgesList.vue?vue&type=style&index=0&id=641eced1&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641eced1"]])

export default __exports__